<template>
    <v-card text>
        <v-toolbar text color="secondary" dense dark>
            <v-app-bar-nav-icon>
                <v-btn icon @click="back">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
            </v-app-bar-nav-icon>
        </v-toolbar>
        <v-card-text :style="floatingBlock">
            <v-form v-model="validate" ref="form">
                <v-layout column>
                    <v-flex>
                        <v-text-field
                            :label="$t('Name')"
                            :hint="$t('Name der neuen Taxonomie')"
                            persistent-hint
                            class="mb-3"
                            v-model="name"
                            :rules="[nonEmpty]"
                        />
                    </v-flex>
                    <v-flex>
                        <compact-picker class="elevation-0" v-model="color" />
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn block color="success" :disabled="!enableCreateTaxonomy" @click="save">{{ $t('Taxonomie erstellen') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import CourseMixin from '../../Mixins/CourseMixin';
import { Compact } from 'vue-color';

export default {
    name: 'create-taxonomy-table',
    mixins: [CourseMixin],
    components: { 'compact-picker': Compact },
    data: () => ({
        color: {
            hex: '#FFFFFF'
        },
        name: '',
        validate: false
    }),
    computed: {
        floatingBlock() {
            let height = '50vh';
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': {
                    height = '90vh';
                    break;
                }
                case 'sm': {
                    height = '70vh';
                    break;
                }
                case 'md': {
                    height = '50vh';
                    break;
                }
                case 'xl': {
                    height = '30vh';
                    break;
                }
            }

            return {
                'max-height': height,
                'overflow-y': 'auto'
            };
        },
        enableCreateTaxonomy() {
            return this.validate && this.color.hasOwnProperty('hex') && this.color.hex !== '' && this.color.hex !== undefined && this.color.hex !== null;
        }
    },
    methods: {
        back() {
            this.$emit('switchComponent', '');
        },
        nonEmpty(value) {
            return !!value || this.$t('Dieses Feld darf nicht leer sein');
        },
        serializeTaxonomy() {
            return {
                name: this.name,
                hexColor: this.color.hex,
                resetable: false,
                folderId: ''
            };
        },
        serializeTaxonomyTable(taxonomy) {
            return {
                id: this.getCourseTaxonomies.id,
                name: 'empty',
                labels: [...this.getCourseTaxonomies.labels, taxonomy],
                folderId: ''
            };
        },
        save() {
            if (this.getCourseTaxonomies.hasOwnProperty('id')) {
                if (this.getCourseTaxonomies.id === null) {
                    this.CREATE_TAXONOMY(this.serializeTaxonomy())
                        .then((taxonomy) => this.CREATE_TAXONOMY_TABLE(this.serializeTaxonomyTable(taxonomy)))
                        .then((response) =>
                            this.UPDATE_COURSE_TAXONOMY_TABLE({
                                course: this.getSelectedAdminCourse,
                                taxonomyTable: response
                            })
                        )
                        .then(this.back());
                } else {
                    this.CREATE_TAXONOMY(this.serializeTaxonomy())
                        .then((taxonomy) => this.UPDATE_TAXONOMY_TABLE(this.serializeTaxonomyTable(taxonomy)))
                        .then((response) =>
                            this.UPDATE_COURSE_TAXONOMY_TABLE({
                                course: this.getSelectedAdminCourse,
                                taxonomyTable: response
                            })
                        )
                        .then(this.back());
                }
            }
        }
    },
    mounted() {
        this.$nextTick(() => this.$refs.form.validate());
    }
};
</script>
